import { sendEmail, getAllUsers, getUserByCard, updateUserPassword } from "../lib/apiClient";

import { UserResponse } from "../interfaces/UserResponse";

export const useUserService = () => {
    const findUser = async (cpfcnpj: string): Promise<UserResponse | null> => {
        const result = await getUserByCard(cpfcnpj);
        return result;
    };

    const findAll = async (): Promise<UserResponse[] | null> => {
        return await getAllUsers();
    };

    const findByEmail = async (email: string): Promise<UserResponse[] | null> => {
        const allUsers = await getAllUsers();

        if (!allUsers) return null;

        return allUsers.filter((u: any) => u.EMAIL === email);
    };

    const emailCheck = async (to: string, subject: string, html: string) => {
        const result = await sendEmail(to, subject, html);
        return result;
    };

    const changePassword = async (id: number, senha: string) => {
        const result = await updateUserPassword(id, senha);
        return result;
    };

    return {
        findUser,
        findAll,
        findByEmail,
        emailCheck,
        changePassword
    }
};